const FAQ_ITEMS = [
  {
    q: '久久影视的电视剧全集免费在线观看需要注册吗？',
    a: '不需要注册即可免费在线观看所有电视剧全集。久久影视致力于为剧迷提供最便捷的追剧体验，打开网站就能直接点播，无需注册登录，无需付费会员。',
  },
  {
    q: '电视剧全集在线观看的画质怎么样？',
    a: '久久影视提供高清画质播放体验，大部分剧集支持 1080P 及以上清晰度。我们采用了先进的视频编码技术和 CDN 加速网络，确保播放流畅不卡顿，给你最佳的观影体验。',
  },
  {
    q: '韩剧全集在线观看有中文字幕吗？',
    a: '是的，所有韩剧全集都配备高质量中文字幕。我们的字幕团队会在剧集更新后第一时间完成翻译校对，确保字幕准确、同步，让你无障碍追韩剧。',
  },
  {
    q: '热门国产剧全集多久更新一次？',
    a: '久久影视每日更新超过 30 部剧集内容。热门国产剧在电视台播出后，我们会以最快速度同步上线全集资源，确保你不会错过任何精彩剧情。',
  },
  {
    q: '久久影视支持手机端观看吗？',
    a: '完全支持！久久影视网站采用响应式设计，在手机、平板、电脑上都能获得良好的观看体验。此外，我们还提供了 iOS 和 Android 客户端下载，支持离线缓存和倍速播放等更多功能。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于电视剧全集免费在线观看的常见疑问
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {FAQ_ITEMS.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="font-heading text-foreground-900 text-base flex items-start gap-3">
                  <span className="text-primary-500 shrink-0 mt-0.5">
                    <i className="ri-question-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-8">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}